import { FunctionComponent } from "react";
import styles from "./AnalyticsFilter.module.css";
import "../../theme-vars.css";

/**
 * Props for AnalyticsFilterValue
 *
 * - title: Label shown for the filter option (e.g., "Today", "MTD")
 * - setFilterState: Callback to update selected filter in parent component
 * - filterType: The filter identifier (MTD, PM, All, T, Y)
 * - filterUsed: Currently active filter from parent component
 * - showFilter: Used to close the dropdown after selection
 */
type props = {
  title: string;
  setFilterState: (data: any) => void;
  filterType: any;
  filterUsed: string;
  showFilter: (data: boolean) => void;
};

/**
 * AnalyticsFilterValue
 *
 * Represents a single radio-button filter option inside AnalyticsFilter.
 * When selected:
 *  - Calls setFilterState with corresponding filter type
 *  - Closes the filter dropdown via showFilter(false)
 */
const AnalyticsFilterValue: FunctionComponent<props> = ({
  title,
  setFilterState,
  filterType,
  filterUsed,
  showFilter,
}) => {

  // Font variables from global CSS theme
  const fontFamilyMain = "var(--font-family-main)";
  const fontSizeSmall = "var(--font-size-small)";

  return (
    <>
      {/* Wrapper row for a single filter option */}
      <div className={styles.box}>
        {/* Filter label */}
        <p
          style={{
            fontFamily: fontFamilyMain,
            fontSize: fontSizeSmall,
            margin: 0
          }}
        >
          {title}
        </p>

        {/* Radio button representing the filter */}
        <input
          type="radio"
          onChange={(e) => {
            if (e.target.checked) {
              setFilterState(filterType);
              showFilter(false); // Close dropdown after selection
            }
          }}
          value={filterType}
          checked={filterUsed === filterType}
        />
      </div>
    </>
  );
};

export default AnalyticsFilterValue;
